import { fetchGetHistoryKlineAsync } from "@/typescript/Services/Api/HuoBiApi";
import { fetchGetProductDataForUserAsync, fetchGetProductListForUserAsync } from "@/typescript/Services/Api/ProductApi";
import HbKlineVO from "@/typescript/Services/SignalRServerVO/HbKlineVO";
import SignalRService from "@/typescript/Services/SignalRService";
import { MessageSystemNoticeTypeEnum } from "@/utils/MessageNoticeEnum";
import Tools from "@/utils/Tools";
import { ProductData, ProductDic } from "@/utils/types/GloablTypes";
import { defineStore } from "pinia";

export const useProductStore = defineStore('product', {
    state: () => ({
        /**
         * 选择的K线时间
         */
        SelectKLineTime: "15min" as '1min' | '5min' | '15min' | '30min' | '4hour' | '1day',
        /**
         * 当前选择的产品编码
         */
        CurrentProductCode: "",
        /**
         * 产品字典
         */
        productDic: {} as ProductDic,
        /**
         * 商品KLine数据
         */
        productKLineDic: {} as { [productCode: string]: { [chTime: string]: HbKlineVO[] } },
    }),
    getters: {
        /**
         * 获取当前的产品数据
         * @returns 
         */
        CurrentProductData(): ProductData {
            const productData = this.productDic[this.CurrentProductCode ?? ''] ?? {};
            return productData;
        },
        /**
         * 获取当前产品的KLine数据
         * @returns 
         */
        CurrentProductKLineData(): HbKlineVO[] {
            if (!this.productKLineDic[this.CurrentProductCode])
                return [];
            if (!this.productKLineDic[this.CurrentProductCode][this.SelectKLineTime])
                return [];
            return this.productKLineDic[this.CurrentProductCode][this.SelectKLineTime];
        },
    },
    actions: {
        /**
         * 监听商品的实时价格
         */
        InitEvent() {
            SignalRService.Instance.AddEventOnce(MessageSystemNoticeTypeEnum.RealTimeKLineData, (kb: HbKlineVO) => {
                const productCode = kb.ProductCode ?? '';
                this.productDic[productCode!].CurrentAmount = kb.Close;
                const chTime = kb.ChTime;
                this.productKLineDic[productCode] ??= {};
                this.productKLineDic[productCode][chTime as any] ??= [];
                const lastKline = this.productKLineDic[productCode][chTime as any][this.productKLineDic[productCode][chTime as any].length - 1];

                // ✅ 判断最后一根的时间是否一致
                if (lastKline && lastKline.KineId === kb.KineId) {
                    Object.assign(lastKline, kb);
                } else {
                    // ➕ 插入新的一根
                    this.productKLineDic[productCode][chTime as any].push(kb);
                }
            });
        },
        /**
         * 获取历史K线数据
         */
        LoadHistoryKLineAsync(productCode: string, period: "1min" | "5min" | "15min" | "30min" | "60min" | "4hour" | "1day" | "1mon" | "1week" | "1year", size: number = 1) {
            return fetchGetHistoryKlineAsync(productCode, period, size);
        },
        /**
         * 获取24H的K线数据
         */
        LoadKlink24HDataAsync(productCode: string) {
            fetchGetHistoryKlineAsync(productCode, "1day", 1).then(resp => {
                if (resp.CheckIsOk()) {
                    if (resp.data) {
                        if (resp.data.length > 0) {
                            const KLink24hData = resp.data[0];
                            this.productDic[productCode].Open24h = KLink24hData.Open ?? 0;
                            this.productDic[productCode].Close24h = KLink24hData.Close ?? 0;
                            this.productDic[productCode].Amount24h = KLink24hData.Amount ?? 0;
                            this.productDic[productCode].Count24h = KLink24hData.Count ?? 0;
                            this.productDic[productCode].Vol24h = KLink24hData.Vol ?? 0;
                            this.productDic[productCode].Low24h = KLink24hData.Low ?? 0;
                            this.productDic[productCode].High24h = KLink24hData.High ?? 0;
                        }
                    }
                }
            });
        },

        /**
         * 根据产品编码获取到产品数据
         * @param productCode 
         * @returns 
         */
        GetProductFromProductCode(productCode: string) {
            return this.productDic[productCode];
        },

        /**
         * 获取商品列表
         */
        async GetProductListAsync() {
            
            const resp = await fetchGetProductListForUserAsync();
            if (resp.CheckIsOk(false)) {
                this.productDic ??= {};
                for (let i = 0; i < resp.data!.length; i++) {
                    const v = resp.data![i];

                    if (Tools.IsNull(this.CurrentProductCode)) {
                        this.CurrentProductCode = v.ProductCode!;
                    }

                    this.productDic[v.ProductCode!] = {
                        ...v,
                        Open24h: 0,
                        Close24h: 0,
                        Amount24h: 0,
                        Count24h: 0,
                        Vol24h: 0,
                        Low24h: 0,
                        High24h: 0
                    };
                    //加载24小时数据
                    this.LoadKlink24HDataAsync(v.ProductCode!);
                }
            }
        }
    }
})